var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "plus.1c9e90e8.png","uri@2x": __webpack_public_path__ + "plus.310dc1e8.png","uri@3x": __webpack_public_path__ + "plus.a96b9a49.png",
    width: 16,
    height: 16
});